import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full container p-4 mx-auto" }
const _hoisted_2 = { class: "py-4" }
const _hoisted_3 = { class: "space-y-8 lg:space-y-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppViewToggle = _resolveComponent("AppViewToggle")!
  const _component_TrendingTokens = _resolveComponent("TrendingTokens")!
  const _component_CreatorsList = _resolveComponent("CreatorsList")!
  const _component_CategoryList = _resolveComponent("CategoryList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppViewToggle)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.allAssetsLoading)
        ? (_openBlock(), _createBlock(_component_TrendingTokens, {
            key: 0,
            tokens: _ctx.allAssets
          }, null, 8, ["tokens"]))
        : _createCommentVNode("", true),
      (!_ctx.featuredCreatorsLoading)
        ? (_openBlock(), _createBlock(_component_CreatorsList, {
            key: 1,
            creators: _ctx.featuredCreators
          }, null, 8, ["creators"]))
        : _createCommentVNode("", true),
      _createVNode(_component_CategoryList)
    ])
  ]))
}